import tw from "twin.macro"
import styled from "@emotion/styled/macro"
import ReactPlayer from "react-player"

import { StyledImage } from "../../Styled/Image"
import { StyledLink } from "../../Styled/Button"
import { H2, P } from "../../Styled/Text"

export const Section = styled.section`
  ${tw`relative flex flex-col items-center justify-center bg-grey-lightest text-navy py-13 md:py-20.5 overflow-hidden`}
  ${({ simple }) => (simple ? tw`py-19.5 md:pt-31 md:pb-34` : tw`md:min-h-140`)}
  ${({ theme }) => theme === `dark` && tw`bg-navy text-white`}
`
export const Title = styled(H2)`
  ${tw`max-w-full w-212`}
  ${({ large }) => (large ? tw`md:text-4.5xl text-left md:text-center` : tw`leading-loose`)}
`
export const Subtitle = tw(P)`hidden md:block mt-11 max-w-full w-212`
export const Player = styled(ReactPlayer)`
  ${tw`absolute inset-0`}

  video {
    ${tw`min-h-full min-w-full w-auto h-auto pointer-events-none object-cover`}
    width: auto !important;
    height: auto !important;
  }
`
export const Content = styled.div`
  ${tw`relative flex flex-col items-center justify-center invisible opacity-0 transition-all duration-200`}
  ${({ active }) => active && tw`visible opacity-100`}
`
export const ButtonOuter = styled.div`
  ${tw`absolute inset-0 flex items-center justify-center w-full h-full transition-all duration-200`}
  ${({ active }) => (active ? tw`opacity-0 hover:opacity-100 visible` : tw`opacity-0 invisible`)}
`
export const Button = styled(StyledLink)`
  ${tw`mt-45 md:mt-11 flex flex-col items-center justify-center text-white transition-all`}
  ${({ hover }) => hover && tw`opacity-75 hover:opacity-100 hover:text-white mt-0 md:mt-0`}
`
export const ButtonText = tw(P)`mt-4 font-bold`
export const Overlay = styled.div`
  ${tw`absolute inset-0 bg-black invisible opacity-0 transition-all duration-200`}
  ${({ active }) => active && tw`visible opacity-50 md:opacity-75`}
`
export const Image = styled(StyledImage)`
  ${tw`opacity-0 invisible transition-all duration-200`}
  ${({ active }) => active && tw`visible opacity-100`}

  &,
  > * {
    ${tw`inset-0`}
    position: absolute !important;
  }
`
